"use strict";

exports.unsafeCoerceEff = function (f) {
  return f;
};



//////////////////
// WEBPACK FOOTER
// ./output/Control.Monad.Eff.Unsafe/foreign.js
// module id = 291
// module chunks = 0